// extracted by mini-css-extract-plugin
module.exports = {"project":"Project_project__3xd3o","project__body":"Project_project__body__HK6Ur"};